import { CCardFooter } from "@coreui/react";
import { Box, Button, Card, CardContent, CardHeader, Divider, IconButton, MenuItem, Modal, Select, SelectChangeEvent, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import {AttachFile, Delete} from '@mui/icons-material'
import { T_Place } from "../../../common/model/placeModel";
import { initialAlert, useAlert } from "../../../provider/AlertContextProvider";
import DaumPostcode from 'react-daum-postcode';
import NeonModal from "../../../component/neon/NeonModal";
import apis from "../../../common/apis";

export default function PlaceInsert(){
 const nav = useNavigate();
    const [cstatus ,setCstatus] = useState('0');
    const [data,setData] = useState<T_Place>({});
    const {alert,setAlert} = useAlert();
    const [isPost,setIsPost] = useState(false)
      const handleComplete = (addrdata:any) => {
    console.log(data)
    setData({...data,zipcode:addrdata.zonecode,addr:addrdata.address + " "+ addrdata.buildingName})
    setIsPost(false); // 주소창은 자동으로 사라지므로 모달만 꺼주면
  };
  const handlePost = () => {
      setIsPost(true);
  }
    const handleModalClose = () => {
    setIsPost(false);
  };

  const saveData = async()=>{

      setAlert({...alert,title:"확인",msg:"정말로 등록 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                   const result = await apis.place.placeCreate(data);
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"등록이 완료되었습니다."})
                        nav("/place")
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"등록중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})

   
  }


    return(
    <>
    <Card >
        <CardHeader title="현장 등록" sx={{pb:0,mb:0}}/>
        <CardContent>
            <Divider />
        <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
          }} > 
            <TableHead />
            <TableBody>
            <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          현장명
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField  size="small" fullWidth value={data.name || ''} onChange={(event)=>{setData({...data,name:event.target.value})}} />
                        </TableCell>      

        </TableRow>        

        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          주소
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                            <Box sx={{flexDirection:'column'}}>
                          <TextField 
                            rows={1}
                            size="small"
                            sx={{mb:1}}
                            value={data.zipcode || ''} onChange={(event)=>{setData({...data,zipcode:event.target.value})}}
                          />
                          <Button onClick={handlePost}>우편번호찾기</Button>
                            </Box>
                        
                          <TextField 
                            rows={1}
                            size="small"
                            sx={{mb:1}}
                            fullWidth 
                            value={data.addr || ''} onChange={(event)=>{setData({...data,addr:event.target.value})}}
                          />
                          <TextField 
                            rows={1}
                            size="small"
                            fullWidth 
                            value={data.addr2 || ''} onChange={(event)=>{setData({...data,addr2:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          비고
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                            <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data.content || ''} onChange={(event)=>{setData({...data,content:event.target.value})}}
                          />                                           
                        </TableCell>      

        </TableRow>        
        </TableBody>

        </Table>

        </CardContent>
        <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
        <Button variant="contained" onClick={()=>{
        saveData();
    }}>저장</Button>
        <Button variant="outlined" onClick={()=>{
        nav(-1);
    }}>취소</Button>

        </CCardFooter>
    </Card>
     <NeonModal
              open={isPost}
              onClose={handleModalClose}
              title="주소검색"
              btnList={[]}
              content={  <DaumPostcode onComplete={handleComplete} />}
            />
   
    </>)

}